import React, { useEffect, useState } from "react";
import { Flex } from "theme-ui";
import Review from "./Review";
import { CarouselProps } from "./TrustPilot";
let count = 0;

const Carousel = (props: CarouselProps) => {
  const { reviews, autoPlay, timing } = props;
  ``;
  const [index, setIndex] = useState(0);
  const [width, setWidth] = useState(0);
  const visible = width < 1280 && width > 768 ? 2 : width < 768 ? 1 : 3;
  const slides = reviews.length / visible;

  useEffect(() => {
    function handleResize() {
      setWidth(window.innerWidth);
    }
    window.addEventListener("resize", handleResize);
    // Clean up event listener on unmount
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (autoPlay) {
      const interval = setInterval(
        () => {
          if (index < slides - 1) {
            setIndex(index + 1);
          } else {
            setIndex(0);
          }
        },
        timing ? timing : 5000
      );

      return () => clearInterval(interval);
    }
  }, [index, autoPlay]);

  const moveSlide = (direction: "back" | "forward") => {
    if (direction === "back") {
      if (index > 0) {
        setIndex(index - 1);
      } else {
        setIndex(slides - 1);
      }
    } else if (direction === "forward") {
      if (index < slides - 1) {
        setIndex(index + 1);
      } else {
        setIndex(0);
      }
    }
  };

  return (
    <Flex
      sx={{
        my: ["30px", null, null, null],
        width: ["100%", null, "650px", "700px", "90%"],
        justifyContent: "center",
      }}
    >
      <Flex
        sx={{
          alignItems: "flex-start",
          flexDirection: "column",
          px: "0px",
        }}
      >
        <Flex
          sx={{
            alignItems: "center",
          }}
        >
          <button
            onClick={() => moveSlide("back")}
            sx={{
              width: "30px",
              height: "30px",
              border: "none",
              bg: "transparent",
            }}
            aria-label="Previous"
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M14.0667 9L11 12.0667L14.0667 15.1333"
                stroke="#979797"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <circle cx="12" cy="12" r="11" stroke="#979797" strokeWidth="2" />
            </svg>
          </button>
          <Flex
            sx={{
              alignItems: "center",
              maxWidth: ["270px", null, "550px", null, "810px"],
              overflow: "hidden",
            }}
          >
            <div
              className="carousel"
              sx={{
                display: "flex",
                transform: [
                  `translateX(-${270 * index}px)`,
                  null,
                  `translateX(-${550 * index - 10 * index}px)`,
                  null,
                  `translateX(-${810 * index}px)`,
                ],
                transition: "all 1s cubic-bezier(.87,.04,.23,.93)",
              }}
            >
              {reviews &&
                reviews.map((review, i) => {
                  count = i % 3;
                  return (
                    <div
                      data-sal="slide-up"
                      data-sal-delay={count * 150}
                      data-sal-duration="1000"
                      data-sal-easing="easeOutQuart"
                      key={i}
                    >
                      <Review {...review} />
                    </div>
                  );
                })}
            </div>
          </Flex>
          <button
            onClick={() => moveSlide("forward")}
            sx={{
              width: "30px",
              height: "30px",
              border: "none",
              bg: "transparent",
            }}
            aria-label="Next"
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M10.9997 9L14.0664 12.0667L10.9997 15.1333"
                stroke="#979797"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <circle cx="12" cy="12" r="11" stroke="#979797" strokeWidth="2" />
            </svg>
          </button>
        </Flex>

        <p
          sx={{
            my: "15px",
            mx: "45px",
            fontSize: "12px",
          }}
        >
          Showing our 5 star reviews
        </p>
      </Flex>
    </Flex>
  );
};

export default Carousel;
